import type { FunctionComponent, PropsWithChildren } from 'react';

import FlowParameters from './FlowParameters';

type ConsentFormProps = PropsWithChildren<{ action?: string }>;

const ConsentForm: FunctionComponent<ConsentFormProps> = ({ children, action = '/authorize/resume' }) => {
  return (
    <form action={action} method="post">
      <FlowParameters />
      {children}
    </form>
  );
};

export default ConsentForm;
